import { render, staticRenderFns } from "./LegalExpertForm.vue?vue&type=template&id=f6b07cc8&scoped=true"
import script from "./LegalExpertForm.vue?vue&type=script&lang=js"
export * from "./LegalExpertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b07cc8",
  null
  
)

export default component.exports